/** Snapshot restoration advances the explicit saved/initial baseline; evaluation updates fields separately. */
import type { StudyBuilderSnapshot } from '@testfeed/shopify-contracts'
export function applyStudyBuilderSnapshotToForm(
  form: { reset: (snapshot: StudyBuilderSnapshot, opts?: { keepDefaultValues?: boolean }) => void },
  snapshot: StudyBuilderSnapshot,
) {
  form.reset(snapshot)
}
